module.exports = __webpack_public_path__ + "static/media/duplicate.319c3816.svg";